import { BugOutlined } from "@ant-design/icons";
import Button from "./Button";
import { useSelector } from "react-redux";
import { selectIsSignedIn } from "@/data/redux/user/selectors";

export default function Feedback() {
  const isSignedIn = useSelector(selectIsSignedIn);
  const yOffset = isSignedIn ? "bottom-20" : "bottom-10";

  return (
    <div className={`fixed ${yOffset} right-4 md:bottom-4`}>
      <Button
        lighter
        icon={<BugOutlined />}
        shadow
        large
        target="_blank"
        href="https://forms.gle/LwAfSjcVHj4oCaDBA"
      >
        Feedback
      </Button>
    </div>
  );
}
